import {BmVectorIcon} from "~/components/icons/simpleIcons";

import {BmWhiteButton, BmWhiteButtonProps} from "../WhiteButton";

export const BmSortingButton: React.FC<BmWhiteButtonProps> = ({...props}) => {
  return (
    <BmWhiteButton
      sx={{
        "&.MuiButton-root": {
          minWidth: "42px",
          p: "0!important",
        },
      }}
      {...props}
    >
      <BmVectorIcon id="sorting-button-icon" />
    </BmWhiteButton>
  );
};
